module.exports = __webpack_public_path__ + "media/img/apple-icon-120x120-582ffaaa2c6b19487ef10dc4436da991.png";